/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as AccessControlSelectors from '../selectors/AccessControlSelectors';
import { getUserAccessRoleId, selectIsAgencyUser } from '../selectors/UserSelectors';
import NoOrgView from '../../common/screens/NoAccessScreens/NoOrgView';
import NoAgencyView from '../../common/screens/NoAccessScreens/NoAgencyView';
import ForbiddenView from '../../common/screens/NoAccessScreens/ForbiddenView';
import * as RouterService from './RouterServices';
import * as OrgSelectors from '../selectors/OrgSelectors';
import { AccessResource, PermissionLevel } from '../../../../shared/types';

type Access = {
  permission: PermissionLevel;
  accessResources: AccessResource[];
};

/**
 * This RouteProps intentionally mimic Route API from latest react-router.
 * However, I am leaving out a few props, intentionally, because I would like us
 * not to use them.
 *
 * @link https://reacttraining.com/react-router/web/api/Route
 */
type RouteProps = {
  path: string | string[];
  strict?: boolean;
  exact?: boolean;
  sensitive?: boolean;
  // Setting this as any for now
  // But really this is React.ComponentType<RouteComponentProps>
  component?: any;
  render?: any;
};
type AccessProps = {
  access?: Access;

  /**
   * redirectTo represent redirection in case, if the route is not allowed
   */
  redirectTo?: string;

  /**
   * We may have to revisit this additionalViews logic.
   * For now, I am going to keep it here.
   */
  additionalViews?: string[];
};
type ExternalProps = RouteProps & AccessProps;
type Props = ExternalProps & {
  allowed?: boolean;
  loading?: boolean;
  accessRoleId?: string;
  isUserOnAgencyView?: boolean;
  isUserOnOrgView?: boolean;
  isAgencyUser?: boolean;
  location?: any;
};
export function ProtectedRoute(props: Props) {
  if (props.loading) {
    return null;
  }

  const { screenAvailableForOrg, screenAvailableForAgency } = RouterService.additionalViews(props.additionalViews);

  if (props.isUserOnAgencyView && !screenAvailableForAgency) {
    return <NoAgencyView />;
  }

  if (props.isUserOnOrgView && !screenAvailableForOrg) {
    return <NoOrgView />;
  }

  if (!props.allowed || RouterService.isRouteRestricted(props.isAgencyUser, props.location)) {
    if (props.redirectTo) {
      return <Redirect to={props.redirectTo} />;
    }

    return (
      <ForbiddenView
        accessResources={props.access && props.access.accessResources}
        role={props.accessRoleId}
        loading={props.loading}
      />
    );
  }

  return (
    <Route
      exact={props.exact}
      strict={props.strict}
      sensitive={props.sensitive}
      path={props.path}
      component={props.component}
      render={props.render || undefined} // undefined is important
    />
  );
}

const mapStateToProps = (state: any, props: ExternalProps) => {
  return {
    loading: AccessControlSelectors.isAccessControlLoading(state),
    allowed: AccessControlSelectors.isAuthorized(state, props.access),
    accessRoleId: getUserAccessRoleId(state),
    isUserOnAgencyView: OrgSelectors.isUserOnAgencyView(state),
    isUserOnOrgView: OrgSelectors.isUserOnOrgView(state),
    isAgencyUser: selectIsAgencyUser(state),
  };
};

const ConnectedProtectedRoute: React.ComponentType<ExternalProps> = connect(
  mapStateToProps,
  null
)(withRouter(ProtectedRoute));
export default ConnectedProtectedRoute;
